<template>
  <v-container class="twilio-whatsapp-shell textoPoppins pa-0" fluid @keydown.ctrl="abrirPegar">
    <v-card class="twilio-whatsapp-app elevation-6">
      <v-row class="ma-0 fill-height twilio-whatsapp-row">
        <v-col
          cols="12"
          md="4"
          lg="4"
          class="pa-0 twilio-whatsapp-sidebar"
          :class="{ 'wa-panel-hidden': isMobileLayout && chat }"
        >
          <div class="wa-sidebar-header">
            <div class="d-flex align-center wa-header-actions">
              <v-avatar color="#00a884" size="42">
                <v-icon color="white">mdi-whatsapp</v-icon>
              </v-avatar>
              <div class="ml-3">
                <div class="wa-title">Twilio Fast</div>
                <div class="wa-subtitle">
                  {{ filterChats.length }} conversaciones<span v-if="tiempoCargaMs != null"> · {{ tiempoCargaMs }} ms</span>
                </div>
              </div>
            </div>

            <div class="d-flex align-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small v-bind="attrs" v-on="on" @click="dialogSeguimiento.estatus = true">
                    <v-icon color="#54656f">mdi-information-outline</v-icon>
                  </v-btn>
                </template>
                <span>Información de seguimiento</span>
              </v-tooltip>

              <v-menu
                v-if="accesosBoton || [334, 3015, 1, 568, 32, 718, 1183, 1258, 2155, 2268, 2269, 2342, 954, 2472, 1312, 2230, 2767, 2910, 2548].includes(getdatosUsuarioERPERP.iderp) || vendedorasTwilio.length"
                bottom
                offset-y
              >
                <template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                      <v-btn icon small v-bind="{ ...menuAttrs, ...tooltipAttrs }" v-on="{ ...menuOn, ...tooltipOn }">
                        <v-icon color="#54656f">mdi-account-switch-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Filtrar por vendedora</span>
                  </v-tooltip>
                </template>

                <v-list dense class="wa-vendedoras-menu" style="min-width: 440px; max-width: 560px;" v-if="!vendedorasTwilio.length">
                  <v-list-item @click="seleccionaVendedora({ iderp: null, nombre: 'Todos', esTodos: true })">
                    <v-list-item-icon class="mr-2">
                      <v-icon color="#00a884">mdi-account-group</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="py-1">
                      <v-list-item-title class="text-caption">Todos</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action class="my-0 ml-2 flex-row align-center" style="min-width: auto;">
                      <v-avatar size="16" color="green" class="mr-1">
                        <v-icon x-small dark>mdi-clock</v-icon>
                      </v-avatar>
                      <span class="text-caption mr-2">{{ conteoTiemposVendedoras.verdesTodos }}</span>
                      <v-avatar size="16" color="yellow darken-1" class="mr-1">
                        <v-icon x-small>mdi-clock</v-icon>
                      </v-avatar>
                      <span class="text-caption mr-2">{{ conteoTiemposVendedoras.amarillosTodos }}</span>
                      <v-avatar size="16" color="blue" class="mr-1">
                        <v-icon x-small dark>mdi-message</v-icon>
                      </v-avatar>
                      <span class="text-caption mr-2">{{ conteoTiemposVendedoras.sinResponderTodos }}</span>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" class="d-inline-flex align-center">
                            <v-avatar size="16" :color="conteoTiemposVendedoras.horaSinContestarTodosColor || 'grey'" class="mr-1">
                              <v-icon x-small dark>mdi-message-clock</v-icon>
                            </v-avatar>
                            <span class="text-caption text-no-wrap" :class="conteoTiemposVendedoras.horaSinContestarTodosClase">{{ conteoTiemposVendedoras.horaSinContestarTodos || '—' }}</span>
                          </span>
                        </template>
                        <span>Hora del último sin responder (sin SPAM / no interesado). Verde: ≤10 min. Rojo: más de 10 min.</span>
                      </v-tooltip>
                    </v-list-item-action>
                  </v-list-item>
                  <v-list-item
                    v-for="(item, index) in vendedorasPlantelOrdenadas"
                    :key="'vp-' + index"
                    @click="seleccionaVendedora(item)"
                  >
                    <v-list-item-icon class="mr-2">
                      <v-icon color="#00a884">mdi-account</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="py-1">
                      <v-list-item-title class="text-caption text-truncate">{{ item.nombre }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action class="my-0 ml-2 flex-row align-center" style="min-width: auto;">
                      <v-avatar size="16" color="green" class="mr-1">
                        <v-icon x-small dark>mdi-clock</v-icon>
                      </v-avatar>
                      <span class="text-caption mr-2">{{ conteoTiempoVendedora(item).verdes }}</span>
                      <v-avatar size="16" color="yellow darken-1" class="mr-1">
                        <v-icon x-small>mdi-clock</v-icon>
                      </v-avatar>
                      <span class="text-caption mr-2">{{ conteoTiempoVendedora(item).amarillos }}</span>
                      <v-avatar size="16" color="blue" class="mr-1">
                        <v-icon x-small dark>mdi-message</v-icon>
                      </v-avatar>
                      <span class="text-caption mr-2">{{ conteoTiempoVendedora(item).sinResponder }}</span>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" class="d-inline-flex align-center">
                            <v-avatar size="16" :color="conteoTiempoVendedora(item).horaSinContestarColor || 'grey'" class="mr-1">
                              <v-icon x-small dark>mdi-message-clock</v-icon>
                            </v-avatar>
                            <span class="text-caption text-no-wrap" :class="conteoTiempoVendedora(item).horaSinContestarClase">{{ conteoTiempoVendedora(item).horaSinContestar || '—' }}</span>
                          </span>
                        </template>
                        <span>Hora del último sin responder (sin SPAM / no interesado). Verde: ≤10 min. Rojo: más de 10 min.</span>
                      </v-tooltip>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>

                <v-list dense class="wa-vendedoras-menu" style="min-width: 440px; max-width: 560px;" v-else>
                  <v-list-item @click="seleccionaVendedora({ iderp: null, nombre: 'Todos', esTodos: true })">
                    <v-list-item-icon class="mr-2">
                      <v-icon color="#00a884">mdi-account-group</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="py-1">
                      <v-list-item-title class="text-caption">Todos</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action class="my-0 ml-2 flex-row align-center" style="min-width: auto;">
                      <v-avatar size="16" color="green" class="mr-1">
                        <v-icon x-small dark>mdi-clock</v-icon>
                      </v-avatar>
                      <span class="text-caption mr-2">{{ conteoTiemposVendedoras.verdesTodos }}</span>
                      <v-avatar size="16" color="yellow darken-1" class="mr-1">
                        <v-icon x-small>mdi-clock</v-icon>
                      </v-avatar>
                      <span class="text-caption mr-2">{{ conteoTiemposVendedoras.amarillosTodos }}</span>
                      <v-avatar size="16" color="blue" class="mr-1">
                        <v-icon x-small dark>mdi-message</v-icon>
                      </v-avatar>
                      <span class="text-caption mr-2">{{ conteoTiemposVendedoras.sinResponderTodos }}</span>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" class="d-inline-flex align-center">
                            <v-avatar size="16" :color="conteoTiemposVendedoras.horaSinContestarTodosColor || 'grey'" class="mr-1">
                              <v-icon x-small dark>mdi-message-clock</v-icon>
                            </v-avatar>
                            <span class="text-caption text-no-wrap" :class="conteoTiemposVendedoras.horaSinContestarTodosClase">{{ conteoTiemposVendedoras.horaSinContestarTodos || '—' }}</span>
                          </span>
                        </template>
                        <span>Hora del último sin responder (sin SPAM / no interesado). Verde: ≤10 min. Rojo: más de 10 min.</span>
                      </v-tooltip>
                    </v-list-item-action>
                  </v-list-item>
                  <v-list-item
                    v-for="(item, index) in vendedorasTwilioOrdenadas"
                    :key="'vt-' + index"
                    @click="seleccionaVendedora(item)"
                  >
                    <v-list-item-icon class="mr-2">
                      <v-icon color="#00a884">mdi-account</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="py-1">
                      <v-list-item-title class="text-caption text-truncate">{{ item.nombre }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action class="my-0 ml-2 flex-row align-center" style="min-width: auto;">
                      <v-avatar size="16" color="green" class="mr-1">
                        <v-icon x-small dark>mdi-clock</v-icon>
                      </v-avatar>
                      <span class="text-caption mr-2">{{ conteoTiempoVendedora(item).verdes }}</span>
                      <v-avatar size="16" color="yellow darken-1" class="mr-1">
                        <v-icon x-small>mdi-clock</v-icon>
                      </v-avatar>
                      <span class="text-caption mr-2">{{ conteoTiempoVendedora(item).amarillos }}</span>
                      <v-avatar size="16" color="blue" class="mr-1">
                        <v-icon x-small dark>mdi-message</v-icon>
                      </v-avatar>
                      <span class="text-caption mr-2">{{ conteoTiempoVendedora(item).sinResponder }}</span>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" class="d-inline-flex align-center">
                            <v-avatar size="16" :color="conteoTiempoVendedora(item).horaSinContestarColor || 'grey'" class="mr-1">
                              <v-icon x-small dark>mdi-message-clock</v-icon>
                            </v-avatar>
                            <span class="text-caption text-no-wrap" :class="conteoTiempoVendedora(item).horaSinContestarClase">{{ conteoTiempoVendedora(item).horaSinContestar || '—' }}</span>
                          </span>
                        </template>
                        <span>Hora del último sin responder (sin SPAM / no interesado). Verde: ≤10 min. Rojo: más de 10 min.</span>
                      </v-tooltip>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-menu>

              <v-tooltip bottom v-if="puedeReasignarMasivo">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    :disabled="!(chatsSeleccionados.length > 0)"
                    @click="abrirReasignacionMasiva"
                  >
                    <v-badge
                      :value="chatsSeleccionados.length > 0"
                      :content="chatsSeleccionados.length"
                      color="#00a884"
                      overlap
                    >
                      <v-icon :color="chatsSeleccionados.length > 0 ? '#00a884' : '#adb5bd'">mdi-account-switch</v-icon>
                    </v-badge>
                  </v-btn>
                </template>
                <span>
                  {{ chatsSeleccionados.length > 0
                    ? `Reasignar ${chatsSeleccionados.length} seleccionado${chatsSeleccionados.length === 1 ? '' : 's'}`
                    : 'Selecciona chats en la lista para reasignar' }}
                </span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small v-bind="attrs" v-on="on" @click="initialize(2)">
                    <v-icon color="#54656f">mdi-refresh</v-icon>
                  </v-btn>
                </template>
                <span>Actualizar chats</span>
              </v-tooltip>
            </div>
          </div>

          <div class="wa-search-panel">
            <v-text-field
              :readonly="filterChats ? false : true"
              v-model="buscarUsuario"
              hide-details
              dense
              solo
              flat
              clearable
              rounded
              :autofocus="buscarUsuarioActive"
              prepend-inner-icon="mdi-magnify"
              placeholder="Buscar o iniciar un chat"
              class="wa-search"
              @input="programarValidacionBusquedaCerrado"
              @keyup.enter="validarBusquedaCerradoEnBd(buscarUsuario)"
              @click:clear="avisoBusquedaCerrado = null"
            ></v-text-field>

            <v-alert
              v-if="avisoBusquedaCerrado"
              dense
              text
              colored-border
              border="left"
              type="warning"
              dismissible
              class="mt-2 mb-1"
              @input="avisoBusquedaCerrado = null"
            >
              <span class="font-weight-bold">{{ avisoBusquedaCerrado }}</span>
            </v-alert>

            <v-progress-linear
              v-if="cargandoBusquedaCerrado"
              indeterminate
              color="#00a884"
              height="2"
              class="mx-2"
            ></v-progress-linear>

            <div class="wa-filter-row">
              <v-btn
                small
                :depressed="filtroFuego"
                class="wa-filter-btn"
                :class="{ 'px-3': true }"
                :fab="!filtroFuego"
                :rounded="filtroFuego"
                :color="filtroFuego ? 'red' : 'white'"
                :dark="filtroFuego"
                @click="activarFiltroFuego"
              >
                <span class="text-h6" :class="{ 'mr-1': filtroFuego }">🔥</span>
                <span v-if="filtroFuego" class="text-caption font-weight-bold">Fuego</span>
              </v-btn>

              <v-btn
                small
                :depressed="filtroHielo"
                class="wa-filter-btn"
                :class="{ 'px-3': true }"
                :fab="!filtroHielo"
                :rounded="filtroHielo"
                :color="filtroHielo ? 'blue' : 'white'"
                :dark="filtroHielo"
                @click="activarFiltroHielo"
              >
                <span class="text-h6" :class="{ 'mr-1': filtroHielo }">🧊</span>
                <span v-if="filtroHielo" class="text-caption font-weight-bold">Hielo</span>
              </v-btn>

              <v-btn
                small
                :depressed="filtroRecomendados"
                class="wa-filter-btn"
                :class="{ 'px-3': true }"
                :fab="!filtroRecomendados"
                :rounded="filtroRecomendados"
                :color="filtroRecomendados ? 'deep-purple' : 'white'"
                :dark="filtroRecomendados"
                @click="activarFiltroRecomendados"
              >
                <v-icon :color="filtroRecomendados ? 'white' : 'deep-purple'" left v-if="filtroRecomendados" x-small>mdi-account-multiple-plus</v-icon>
                <span v-if="filtroRecomendados" class="text-caption font-weight-bold">rec</span>
                <span v-else class="text-caption font-weight-bold purple--text text--darken-2">rec</span>
              </v-btn>

              <v-btn
                small
                :depressed="filtroMensajes"
                class="wa-filter-btn"
                :class="{ 'px-3': true }"
                :fab="!filtroMensajes"
                :rounded="filtroMensajes"
                :color="filtroMensajes ? 'red' : 'white'"
                :dark="filtroMensajes"
                @click="activarFiltroMensajes"
              >
                <v-icon :color="filtroMensajes ? 'white' : 'red'" left v-if="filtroMensajes">mdi-message-badge</v-icon>
                <v-icon :color="filtroMensajes ? 'white' : 'red'" v-else>mdi-message-badge</v-icon>
                <span v-if="filtroMensajes" class="text-caption font-weight-bold">4+ msgs</span>
              </v-btn>

              <v-tooltip v-if="puedeVerFiltroFinalizo" bottom max-width="260">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    :depressed="filtroFinalizo"
                    class="wa-filter-btn"
                    :class="{ 'px-3': true }"
                    :fab="!filtroFinalizo"
                    :rounded="filtroFinalizo"
                    :color="filtroFinalizo ? 'teal darken-1' : 'white'"
                    :dark="filtroFinalizo"
                    v-bind="attrs"
                    v-on="on"
                    @click="activarFiltroFinalizo"
                  >
                    <v-icon :color="filtroFinalizo ? 'white' : 'teal darken-1'" left v-if="filtroFinalizo">mdi-file-check-outline</v-icon>
                    <v-icon :color="filtroFinalizo ? 'white' : 'teal darken-1'" v-else>mdi-file-check-outline</v-icon>
                    <span v-if="filtroFinalizo" class="text-caption font-weight-bold">Finalizó</span>
                  </v-btn>
                </template>
                <span>Solo chats cuyo historial tiene el mensaje de ficha (pre-registro / *Nombre:*…). Clic de nuevo para quitar.</span>
              </v-tooltip>

              <v-tooltip v-if="puedeVerFiltroAgenteIA" bottom max-width="260">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    :depressed="filtroAgenteIA"
                    class="wa-filter-btn"
                    :class="{ 'px-3': true }"
                    :fab="!filtroAgenteIA"
                    :rounded="filtroAgenteIA"
                    :color="filtroAgenteIA ? 'deep-purple' : 'white'"
                    :dark="filtroAgenteIA"
                    v-bind="attrs"
                    v-on="on"
                    @click="activarFiltroAgenteIA"
                  >
                    <v-icon :color="filtroAgenteIA ? 'white' : 'deep-purple'" left v-if="filtroAgenteIA">mdi-robot</v-icon>
                    <v-icon :color="filtroAgenteIA ? 'white' : 'deep-purple'" v-else>mdi-robot</v-icon>
                    <span v-if="filtroAgenteIA" class="text-caption font-weight-bold">Agente IA</span>
                  </v-btn>
                </template>
                <span>Solo chats que entraron por Agente IA (chip IA). Clic de nuevo para quitar.</span>
              </v-tooltip>

              <v-btn
                rounded
                class="wa-filter-clear"
                @click="limpiarFiltrosLista"
              >
                Todos!!
              </v-btn>

              <v-btn
                small
                :depressed="filtroVistos"
                class="wa-filter-btn"
                :class="{ 'px-3': true }"
                :fab="!filtroVistos"
                :rounded="filtroVistos"
                :color="filtroVistos ? 'grey darken-2' : 'white'"
                :dark="filtroVistos"
                @click="filtroVistos = !filtroVistos"
              >
                <v-icon :color="filtroVistos ? 'white' : 'grey darken-2'" left v-if="filtroVistos">mdi-message-bulleted-off</v-icon>
                <v-icon :color="filtroVistos ? 'white' : 'grey darken-2'" v-else>mdi-message-bulleted-off</v-icon>
                <span v-if="filtroVistos" class="text-caption font-weight-bold">Sin responder</span>
              </v-btn>

              <v-menu bottom offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    :depressed="!!etiqueta"
                    class="wa-filter-btn"
                    :class="{ 'px-3': true }"
                    :fab="!etiqueta"
                    :rounded="!!etiqueta"
                    :color="etiqueta ? (etiqueta.color || 'grey darken-2') : 'white'"
                    :dark="!!etiqueta"
                    v-bind="attrs"
                    v-on="etiqueta ? {} : on"
                    @click="onClickBotonEtiqueta"
                  >
                    <v-icon :color="etiqueta ? 'white' : 'grey darken-2'" left v-if="etiqueta">mdi-label</v-icon>
                    <v-icon :color="etiqueta ? 'white' : 'grey darken-2'" v-else>mdi-checkbox-blank-circle</v-icon>
                    <span v-if="etiqueta" class="text-caption font-weight-bold">{{ etiqueta.text }}</span>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item v-for="(item, index) in etiquetas" :key="index" @click="seleccionarEtiqueta(item)">
                    <v-list-item-title class="text-caption">
                      <v-icon small :color="item.color">mdi-label</v-icon>
                      {{ item.text }} {{ item.count ? '(' + item.count + ')' : '' }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <v-menu bottom offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    :depressed="!!filtroTiempo"
                    class="wa-filter-btn"
                    :class="{ 'px-3': true }"
                    :fab="!filtroTiempo"
                    :rounded="!!filtroTiempo"
                    :color="filtroTiempo ? (filtroTiempo.color || 'grey darken-2') : 'white'"
                    :dark="!!filtroTiempo"
                    v-bind="attrs"
                    v-on="filtroTiempo ? {} : on"
                    @click="onClickBotonTiempo"
                  >
                    <v-icon :color="filtroTiempo ? 'white' : 'grey darken-2'" left v-if="filtroTiempo">mdi-clock</v-icon>
                    <v-icon :color="filtroTiempo ? 'white' : 'grey darken-2'" v-else>mdi-clock</v-icon>
                    <span v-if="filtroTiempo" class="text-caption font-weight-bold">{{ filtroTiempo.text }}</span>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item v-for="(item, index) in tiempos" :key="index" @click="seleccionarFiltroTiempo(item)">
                    <v-list-item-title class="text-caption">
                      <v-icon small :color="item.color">mdi-clock</v-icon>
                      {{ item.text }} {{ item.count != null ? '(' + item.count + ')' : '' }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <div v-if="accesosBoton" class="wa-select-tooltip">
                <v-select
                  class="wa-select wa-incompletos-select"
                  dense
                  hide-details
                  solo
                  flat
                  rounded
                  :items="opcionesIncompletos"
                  label="Incompletos"
                  v-model="filtroIncompletos"
                  item-value="value"
                  item-text="text"
                  clearable
                ></v-select>
              </div>
            </div>
          </div>

          <ListaContactos
            :filterChats="filterChats"
            :whatsapp-style="true"
            :chat-activo="chat"
            :mostrar-marca-ia-susana="puedeVerMarcaIaSusana"
            :permitir-seleccion="puedeReasignarMasivo"
            :seleccionados.sync="chatsSeleccionados"
            @verChat="verChat"
            :limite="limite"
            @cargar-mas="onCargarMasChats"
          />
        </v-col>

        <v-col
          cols="12"
          md="8"
          lg="8"
          class="pa-0 twilio-whatsapp-conversation"
          :class="{ 'wa-panel-hidden': isMobileLayout && !chat }"
        >
          <div v-if="!chat" class="wa-empty-state">
            <v-icon size="96" color="#d1d7db">mdi-whatsapp</v-icon>
            <h2>WhatsApp CRM</h2>
            <p>Selecciona un chat para ver la conversación en tiempo real.</p>
          </div>

          <template v-else>
            <div class="wa-chat-header">
              <div class="d-flex align-center overflow-hidden">
                <v-btn
                  v-if="isMobileLayout"
                  icon
                  small
                  class="wa-back-btn"
                  @click="cerrarChatMobile"
                >
                  <v-icon color="#54656f">mdi-arrow-left</v-icon>
                </v-btn>
                <v-avatar :color="!chat.nombre ? '#00a884' : '#dfe5e7'" size="44">
                  <v-icon color="white" v-if="!chat.nombre">mdi-account</v-icon>
                  <span v-else class="wa-avatar-text">{{ chat.nombre }}</span>
                </v-avatar>
                <div class="ml-3 overflow-hidden">
                  <div class="wa-chat-name">{{ chat.usuario }}</div>
                  <div class="wa-chat-meta" v-if="chat.folio">Folio {{ chat.folio }}</div>
                  <div class="wa-chat-timing" v-if="tiempoCargaChatMs != null">
                    twilio.chats.unico · {{ tiempoCargaChatMs }} ms
                  </div>
                </div>
              </div>

              <div class="wa-chat-actions">
                <v-btn
                  v-if="[1, 3, 568, 334, 3015, 2268, 2155, 2472, 1312,2230,954, 2767,2910].includes(getdatosUsuarioERPERP.iderp) && chat.folio"
                  small
                  rounded
                  depressed
                  color="#ffffff"
                  class="wa-action-btn"
                  @click="abrirReasignacionIndividual"
                >
                  <v-icon small left>mdi-account-switch</v-icon>
                  Reasignar
                </v-btn>

                <v-btn
                  v-if="puedeExportarConversacionIA"
                  small
                  rounded
                  depressed
                  color="#ffffff"
                  class="wa-action-btn"
                  @click="abrirJsonConversacionIA('twilio-fast')"
                >
                  <v-icon small left>mdi-code-json</v-icon>
                  JSON IA
                </v-btn>

                <v-btn
                  v-if="[1, 3, 568, 334, 3015, 2268, 2155, 2472, 1312,2230,954, 2767,2910].includes(getdatosUsuarioERPERP.iderp) && !chat.folio"
                  small
                  rounded
                  depressed
                  color="#ffffff"
                  class="wa-action-btn"
                  @click="dialogAsignar.estatus = true"
                >
                  <v-icon small left>mdi-account-plus</v-icon>
                  Asignar
                </v-btn>

                <v-menu top offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small v-bind="attrs" v-on="on" v-if="chat.idetiquetas != 6">
                      <v-icon color="#54656f">mdi-label-outline</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item v-for="(item, index) in etiquetas2" :key="index" @click="cambiarCategoria(item.idetiquetas)">
                      <v-list-item-title class="text-caption">
                        <v-icon small :color="item.color">mdi-label</v-icon>
                        {{ item.text }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-btn icon small @click="dialogComentariosAbiertoChat = true">
                  <v-icon color="#54656f">mdi-comment-plus-outline</v-icon>
                </v-btn>

                <v-btn icon small @click="dialogDescrip = true">
                  <v-icon color="#54656f">mdi-dots-vertical</v-icon>
                </v-btn>
              </div>
            </div>

            <section class="wa-chat-area">
              <v-container
                id="scroll-target"
                v-scroll:#scroll-target="onScroll"
                class="wa-messages-scroll overflow-y-auto elevation-0"
              >
                <MensajesWppTwilio
                  class="messages-chat elevation-0"
                  id="mensajesChat"
                  :whatsappStyle="true"
                  :mensajes="mensajes"
                  :alumno="alumno"
                  :wha="wha"
                  :chat="chat"
                  :verTodosLosMensajes="verTodosLosMensajes"
                  :asignacion="asignacion"
                  :numeroTwilio="numeroTwilio"
                  :composerDeshabilitadoPorControl="chatSoloLecturaCerrado"
                  :mensajeComposerDeshabilitado="chatSoloLecturaCerrado ? 'Contacto bloqueado (spam) — solo lectura' : ''"
                  @validayGuardaMensajes="validayGuardaMensajes"
                  :chats="getConversacionesFast"
                  @verChat="verChat"
                />
              </v-container>
            </section>
          </template>
        </v-col>
      </v-row>
    </v-card>

    <v-dialog v-model="dialogDescrip" max-width="500px" transition="dialog-transition">
      <v-card>
        <v-card-title primary-title>
          Etiquetas
        </v-card-title>
        <v-card-text class="black--text">
          <div v-for="(etiqueta, i) in etiquetas" :key="i">
            <v-icon :color="etiqueta.color">mdi-label</v-icon><b>{{ etiqueta.etiqueta }}</b>
            <br/>
            {{ etiqueta.detalles }}
            <br/>
            <br/>
            <v-divider></v-divider>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogComentariosAbiertoChat" max-width="600px" scrollable>
      <v-card v-if="chat && chat.idprospectos">
        <v-card-title class="headline">
          <v-icon small class="mr-2">mdi-chat-multiple</v-icon>
          Comentarios del Prospecto
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="min-height: 400px;">
          <ComentariosProspecto :idProspecto="chat.idprospectos" />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogComentariosAbiertoChat = false">
            <v-icon small class="mr-1">mdi-close</v-icon>
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ReasignarProspecto
      :dialogReasignar="dialogReasignar"
      v-if="dialogReasignar.estatus"
      :alumno="alumno"
      :wha="wha"
      :chat="chat"
      :chats="chatsParaReasignar"
      :escuela="2"
      @reasignado="onReasignacionManual"
    />

    <AsignarProspecto
      :escuela="2"
      :dialogAsignar="dialogAsignar"
      v-if="dialogAsignar.estatus"
      :alumno="alumno"
      :wha="wha"
      :chat="chat"
    />

    <InfoSeguimiento
      :dialogSeguimiento="dialogSeguimiento"
      v-if="dialogSeguimiento.estatus"
    />

    <DialogJsonConversacionIA
      v-if="puedeExportarConversacionIA"
      v-model="dialogJsonConversacionIA"
      :jsonStr="jsonConversacionIA"
      @copiar="copiarJsonConversacionIA"
      @descargar="descargarJsonConversacionIA"
    />

    <Alerta v-if="respuestaAlerta" :parametros="parametros"/>
    <carga v-if="cargar"/>
  </v-container>
</template>

<script>
  import axios          from 'axios';
  import { mapGetters, mapActions } from 'vuex'
  // import { io }         from "socket.io-client";

  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import MensajesWppTwilio     from '@/components/whatsapp/MensajesTwilioWpp.vue';
  import ListaContactos        from '@/components/whatsapp/ListaContactos.vue';
  import ReasignarProspecto    from '@/components/whatsapp/ReasignarProspecto.vue';
  import InfoSeguimiento       from '@/components/whatsapp/InfoSeguimiento.vue';
  import AsignarProspecto      from '@/components/whatsapp/AsignarProspecto.vue';
  import ComentariosProspecto  from '@/components/ComentariosProspecto.vue';
  import DialogJsonConversacionIA from '@/components/whatsapp/DialogJsonConversacionIA.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import mixinWhatsApp         from '@/mixins/mixinWhatsApp'
  import mixinEstatusWha       from '@/mixins/mixinEstatusWha'
  import mixinExamenTwilioAbrir from '@/mixins/mixinExamenTwilioAbrir'
  import mixinTwilioChatTiming from '@/mixins/mixinTwilioChatTiming'
  import mixinTwilioWhatsAppLayout from '@/mixins/mixinTwilioWhatsAppLayout'
  import mixinExportarConversacionTwilioIA from '@/mixins/mixinExportarConversacionTwilioIA'
  import { chatCoincideBusquedaTwilio } from '@/utils/examenUbicacionNotify'
  import { chatTieneFichaTecnica } from '@/utils/twilioFichaTecnica'
  import {
    debeOcultarChatSinProspectoPuesto18,
    chatTieneFolioOProspecto,
    chatViaAgenteIA,
    mensajeLimpiaReasignado,
  } from '@/utils/twilioVendedoraProspecto'
  import { esUsuarioTwilioAdmin } from '@/config/twilioUsuariosAdmin'
  import {
    formatFechaMexicoFront,
    ordenarChatsPorMasReciente,
    aplicarHoraSinContestar,
    maxHoraSinContestarDeMap,
    colorHoraSinContestar,
    colorHoraSinContestarGrupo,
    claseTextoHoraSinContestar,
    chatsParaHoraMenuEncargadas,
  } from '@/utils/twilioFechaMexico'

  export default {
    components:{
      Alerta,
      carga,
      MensajesWppTwilio,
      ListaContactos,
      ReasignarProspecto,
      InfoSeguimiento,
      AsignarProspecto,
      ComentariosProspecto,
      DialogJsonConversacionIA,

    },

    mixins: [ validarErrores, mixinEstatusWha, mixinWhatsApp, mixinExamenTwilioAbrir, mixinTwilioChatTiming, mixinTwilioWhatsAppLayout, mixinExportarConversacionTwilioIA ],


    data: () => ({
      skipMixinWhatsAppInit: true,
      dialogDescrip: false,
      dialogComentariosAbiertoChat: false,
      buscarPregunta:'',
      buscarActive:false,

      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      cargar: false,

      usuarios:[],

      usuario: null,
      buscarUsuario:'',
      buscarUsuarioActive:true,
      avisoBusquedaCerrado: null,
      cargandoBusquedaCerrado: false,
      timerBusquedaCerrado: null,
      reqBusquedaCerrado: 0,
      alumno:null,
      url: 'https://escuelakpi.club/kpi/whatsapp-imagenes/',

      notSeen:false,
      searchMensaje:'',
      mensajes:[],
      chat:null,

      wha: null,
      notResponse:false,

      verTodosLosMensajes: 0,
      message: '',

      parametrosAsignarVendedora:{
        estatus: false
      },
      asignacion: null,
      conversaciones:[],
      asignados:[],
      loader: true,

      sonido: null,

      numeroTwilio: "whatsapp:+5218123255321",

      offsetTop: 0,

      limite: 30,
      tiempoCargaMs: null,
      // Misma intención que Unificado (chatsLimitPedido): 100 dejaba fuera contactos recientes.
      chatsApiPageSize: 2000,
      chatsPagination: null,
      cargandoMasChats: false,

      filtroFuego: false,
      filtroFinalizo: false,
      filtroAgenteIA: false,
      filtroSinProspecto: false,
      filtroSinProspectoNoInteres:false,
      filtroHielo: false,
      filtroRecomendados: false,
      filtroMensajes:false,

      filtroVistos: false,
      filtroIncompletos: null,
      opcionesIncompletos: [
        { text: 'Incompletos con interés', value: 'con_interes' },
        { text: 'Incompletos sin interés', value: 'sin_interes' },
        { text: 'Sin incompletos', value: 'sin_incompletos' },
      ],
      etapa: 8,
      etiqueta: null,

      filtroTiempo: false,
      escuela: '2',
      filtroVendedora: null,
      vendedoras_plantel:[],

      dialogReasignar: {
        estatus: false
      },
      reasignacionMasiva: false,
      chatsSeleccionados: [],
      dialogSeguimiento:{
        estatus: false
      },

      dialogAsignar:{
        estatus: false
      },

      /**
       * Snapshot de conteos del menú (verdes/amarillos/sinResponder/horaSinContestar).
       * Se actualiza solo con la lista completa (Todos); al filtrar una vendedora
       * no se pisa para que las demás no queden en 0.
       */
      conteoVendedorasSnapshot: null,

    }),

    computed: {
      ...mapGetters('login',['getdatosUsuarioERPERP']),
      ...mapGetters('twilio',['getConversacionesM','getConversacionesC', 'getConversacionesG','getConversacionesFast']),

      puedeVerFiltroFinalizo () {
        return [1, 28, 334, 568, 3176].includes(Number(this.getdatosUsuarioERPERP.iderp))
      },

      puedeVerMarcaIaSusana () {
        return [1, 32, 334, 568].includes(Number(this.getdatosUsuarioERPERP.iderp))
      },

      puedeVerFiltroAgenteIA () {
        return [1, 28, 334, 568].includes(Number(this.getdatosUsuarioERPERP.iderp))
      },

      puedeReasignarMasivo () {
        return [1, 334, 568, 2767].includes(Number(this.getdatosUsuarioERPERP.iderp))
      },

      chatsParaReasignar () {
        if (this.reasignacionMasiva && this.chatsSeleccionados.length) {
          return this.chatsSeleccionados
        }
        return null
      },

      accesosBoton( ){

        return esUsuarioTwilioAdmin(this.getdatosUsuarioERPERP.iderp) || [568, 334, 1, 32, 1312, 2230, 954, 2767, 2910].includes(this.getdatosUsuarioERPERP.iderp)

      },

      /** Spam bloqueado: ver historial sin enviar. Ventana 24h la maneja MensajesTwilioWpp (tiemporestante). */
      chatSoloLecturaCerrado () {
        return !!(this.chat && Number(this.chat.idetiquetas) === 6)
      },

      filterChats(){

        // Preferir el store; si aún no sincroniza, usar fallback local
        let chats = (this.getConversacionesFast && this.getConversacionesFast.length)
          ? this.getConversacionesFast
          : (Array.isArray(this.conversaciones) ? this.conversaciones : [])

        // Reasignados: forzar sinleer=1 y mio=0 para chip azul y orden
        chats = (Array.isArray(chats) ? chats : []).map((el) => {
          if (!el || Number(el.reasignado) !== 1) return el
          const sinleer = Math.max(Number(el.sinleer) || 0, 1)
          if (sinleer === Number(el.sinleer) && Number(el.mio) === 0) return el
          return { ...el, sinleer, mio: 0 }
        })

        // Puesto 18: sin folio ni idprospectos no se muestra (evita bumps de socket sin CRM)
        if (Number(this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.idpuesto) === 18) {
          chats = chats.filter(el => chatTieneFolioOProspecto(el))
        }

        if (this.buscarUsuario) {
          const q = String(this.buscarUsuario).trim()
          chats = chats.filter(el => chatCoincideBusquedaTwilio(el, q))
        }

        // Misma prioridad que Unificado: ventanas abiertas arriba, cerradas al final
        chats = ordenarChatsPorMasReciente(chats)

        if( this.filtroFuego && !this.filtroHielo ){
          chats = chats.filter( el => el.nombre == '🔥' )
        }

        if (this.filtroFinalizo) {
          // No usar solo folio: se asigna al crear prospecto IA, antes de la ficha
          chats = chats.filter(chatTieneFichaTecnica)
        }

        if (this.filtroAgenteIA) {
          chats = chats.filter(chatViaAgenteIA)
        }

        if( this.filtroMensajes ){
          chats = chats.filter( el => Number(el.totalMensajes) >= 4 )
        }

        if( this.filtroHielo && !this.filtroFuego ){
          chats = chats.filter( el => el.nombre == '🧊' )
        }

        if (this.filtroRecomendados) {
          chats = chats.filter(el => Number(el.es_recomendado) === 1)
        }

        if( this.etapa && this.etapa != 8 ){

          chats = chats.filter( el => el.idetapa == this.etapa )

        }

        if( this.filtroVistos ){

          chats = chats.filter( el => el.mio == 0 )

        }

        // Conteos del menú: calcular antes del filtro de etiqueta activa
        this.conteoEtiquetas(chats)

        if( this.etiqueta ){

          chats = chats.filter( el => el.idetiquetas == this.etiqueta.idetiquetas )

        }

        this.conteoIncompletos(chats)

        if( this.filtroIncompletos ){
          if( this.filtroIncompletos == 'con_interes' ){
            chats = chats.filter(el => !el.folio && Number(el.totalMensajes) >= 2)
          } else if( this.filtroIncompletos == 'sin_interes' ){
            chats = chats.filter(el => !el.folio && Number(el.totalMensajes)  < 2)
          } else if( this.filtroIncompletos == 'sin_incompletos' ){
            chats = chats.filter(el => el.folio )
          }
        }

        this.conteoTiempos(chats)

        if( this.filtroTiempo ){

          if( this.filtroTiempo.idtiempos == 1 ){
            chats = chats.filter( el => el.tiemporestante > 2 )
          }else if( this.filtroTiempo.idtiempos == 2 ){
            chats = chats.filter( el => el.tiemporestante > 0 && el.tiemporestante <= 2 )
          }else if( this.filtroTiempo.idtiempos == 3 ){
            chats = chats.filter( el => el.tiemporestante <= 0 )
          }


        }
        return chats
      },

      filterFiltro( ){

        let filtro = [
          { id: 2, text: `Nuevo (${this.getConversacionesFast.filter( el => el.idetapa == 2).length})` },
          { id: 1, text: `Atrasado (${this.getConversacionesFast.filter( el => el.idetapa == 1).length})` },
          { id: 4, text: `Con Info (${this.getConversacionesFast.filter( el => el.idetapa == 4).length})` },
          { id: 5, text: `Sin info (${this.getConversacionesFast.filter( el => el.idetapa == 5).length})` },
          { id: 7, text: `2da Contacto (${this.getConversacionesFast.filter( el => el.idetapa == 7).length})` },
          { id: 8, text: `Todos (${this.getConversacionesFast.length})` },
        ]

        return filtro
      },

      filterVendedoras( ){
        return this.vendedoras.filter( el => el.escuela == this.escuela )
      },

      chatsMenuEncargadas () {
        let chats = (this.getConversacionesFast && this.getConversacionesFast.length)
          ? this.getConversacionesFast
          : (Array.isArray(this.conversaciones) ? this.conversaciones : [])
        if (!Array.isArray(chats)) return []

        if (Number(this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.idpuesto) === 18) {
          chats = chats.filter(el => chatTieneFolioOProspecto(el))
        }
        if (this.filtroFuego && !this.filtroHielo) chats = chats.filter(el => el.nombre == '🔥')
        if (this.filtroFinalizo) chats = chats.filter(chatTieneFichaTecnica)
        if (this.filtroAgenteIA) chats = chats.filter(chatViaAgenteIA)
        if (this.filtroMensajes) chats = chats.filter(el => Number(el.totalMensajes) >= 4)
        if (this.filtroHielo && !this.filtroFuego) chats = chats.filter(el => el.nombre == '🧊')
        if (this.filtroRecomendados) chats = chats.filter(el => Number(el.es_recomendado) === 1)
        if (this.etapa && this.etapa != 8) chats = chats.filter(el => el.idetapa == this.etapa)
        if (this.etiqueta) chats = chats.filter(el => el.idetiquetas == this.etiqueta.idetiquetas)
        if (this.filtroIncompletos == 'con_interes') {
          chats = chats.filter(el => !el.folio && Number(el.totalMensajes) >= 2)
        } else if (this.filtroIncompletos == 'sin_interes') {
          chats = chats.filter(el => !el.folio && Number(el.totalMensajes) < 2)
        } else if (this.filtroIncompletos == 'sin_incompletos') {
          chats = chats.filter(el => el.folio)
        }
        if (this.filtroTiempo) {
          if (this.filtroTiempo.idtiempos == 1) chats = chats.filter(el => el.tiemporestante > 2)
          else if (this.filtroTiempo.idtiempos == 2) chats = chats.filter(el => el.tiemporestante > 0 && el.tiemporestante <= 2)
          else if (this.filtroTiempo.idtiempos == 3) chats = chats.filter(el => el.tiemporestante <= 0)
        }
        return chats
      },

      chatsHoraEncargadas () {
        const idFiltro = this.filtroVendedora && !this.filtroVendedora.esTodos
          ? Number(
              this.filtroVendedora.iderp
              || this.filtroVendedora.id_usuario_asignado
              || this.filtroVendedora.idusuario
            )
          : 0
        return chatsParaHoraMenuEncargadas(this.chatsMenuEncargadas, this.filterChats, idFiltro)
      },

      conteoTiemposVendedoras () {
        const live = this.calcularConteoVendedorasDesdeChats(this.chatsHoraEncargadas)
        const idFiltro = this.filtroVendedora && !this.filtroVendedora.esTodos
          ? Number(
              this.filtroVendedora.iderp
              || this.filtroVendedora.id_usuario_asignado
              || this.filtroVendedora.idusuario
            )
          : 0

        let base = live
        if (idFiltro > 0 && this.conteoVendedorasSnapshot) {
          const map = Object.assign({}, this.conteoVendedorasSnapshot.map)
          Object.keys(live.map || {}).forEach((id) => {
            map[id] = live.map[id]
          })
          base = {
            ...this.conteoVendedorasSnapshot,
            map,
            ...maxHoraSinContestarDeMap(map),
          }
        }

        const color = colorHoraSinContestarGrupo(base && base.map)
        return {
          ...base,
          horaSinContestarTodosColor: color,
          horaSinContestarTodosClase: claseTextoHoraSinContestar(color),
        }
      },

      vendedorasPlantelOrdenadas () {
        return this.ordenarVendedorasPorVerdes(this.vendedoras_plantel)
      },

      vendedorasTwilioOrdenadas () {
        return this.ordenarVendedorasPorVerdes(this.vendedorasTwilio)
      },

      tamanioPantalla () {
        return this.$vuetify.breakpoint.height -280
      },

    },

    watch:{
      filtroVendedora( value ){
        if (this._omitirWatchFiltroVendedora) return

        if (value && value.esTodos) {
          this.getUsersChats()
          return
        }
        this.initialize(2)
      },

      buscarUsuario (value) {
        this.programarValidacionBusquedaCerrado(value)
      },

      getConversacionesFast () {
        this.$nextTick(() => this.tryAbrirChatExamenPendiente())
      },
    },

    async created (){
      await this.getVendedoras()
      await this.getAccesosCRM()
      this.crearTemplateSonido()
      this.getTwilioTmp()

      const tieneEquipo =
        Array.isArray(this.vendedorasTwilio) && this.vendedorasTwilio.length > 0

      if (!this.accesosBoton && tieneEquipo) {
        this._omitirWatchFiltroVendedora = true
        this.filtroVendedora = {
          iderp: null,
          nombre: 'Todos',
          esTodos: true,
        }
        await this.getUsersChats()
        this._omitirWatchFiltroVendedora = false
      } else {
        await this.initialize(2)
      }

      this.syncPendingExamenDesdeRuta()
    },

    methods: {
      /**
       * Sin responder (icono azul):
       * - Reasignados IA, aunque el último mensaje sea nuestro
       * - Último mensaje del lead (mio == 0)
       * - No cuenta fuera de tiempo (chip rojo: tiemporestante <= 0)
       */
      esChatSinResponder (chat) {
        if (!chat) return false
        if (!(Number(chat.tiemporestante) > 0)) return false
        if (Number(chat.reasignado) === 1 || chat.reasignado === true) return true
        return chat.mio == 0
      },

      calcularConteoVendedorasDesdeChats (chats) {
        const map = {}
        let verdesTodos = 0
        let amarillosTodos = 0
        let sinResponderTodos = 0
        const lista = Array.isArray(chats) ? chats : []

        for (const chat of lista) {
          if (!chat) continue
          const id = Number(chat.usuario_asignado)
          if (!id) continue
          const t = Number(chat.tiemporestante)
          if (!map[id]) {
            map[id] = {
              verdes: 0,
              amarillos: 0,
              sinResponder: 0,
              horaSinContestarMs: 0,
              horaSinContestar: '—',
            }
          }

          if (t > 2) {
            map[id].verdes++
            verdesTodos++
          } else if (t > 0 && t <= 2) {
            map[id].amarillos++
            amarillosTodos++
          }

          if (this.esChatSinResponder(chat)) {
            map[id].sinResponder++
            sinResponderTodos++
          }

          aplicarHoraSinContestar(map[id], chat)
        }

        return {
          map,
          verdesTodos,
          amarillosTodos,
          sinResponderTodos,
          ...maxHoraSinContestarDeMap(map),
        }
      },

      /**
       * Snapshot del menú:
       * - Lista completa (Todos): reemplaza todo.
       * - Una vendedora: actualiza solo su conteo con lo que trajo la API (para que cuadre con el filtro).
       */
      actualizarConteoVendedorasSnapshot (chats) {
        const parcial = this.calcularConteoVendedorasDesdeChats(chats)
        const idFiltro = this.filtroVendedora && !this.filtroVendedora.esTodos
          ? Number(
              this.filtroVendedora.iderp
              || this.filtroVendedora.id_usuario_asignado
              || this.filtroVendedora.idusuario
            )
          : 0

        if (idFiltro > 0) {
          const snap = this.conteoVendedorasSnapshot || {
            map: {},
            verdesTodos: 0,
            amarillosTodos: 0,
            sinResponderTodos: 0,
            horaSinContestarTodos: '—',
            horaSinContestarTodosMs: 0,
          }
          const prev = snap.map[idFiltro] || {
            verdes: 0,
            amarillos: 0,
            sinResponder: 0,
            horaSinContestarMs: 0,
            horaSinContestar: '—',
          }
          const next = parcial.map[idFiltro] || {
            verdes: 0,
            amarillos: 0,
            sinResponder: 0,
            horaSinContestarMs: 0,
            horaSinContestar: '—',
          }
          const map = Object.assign({}, snap.map, { [idFiltro]: next })
          this.conteoVendedorasSnapshot = {
            map,
            verdesTodos: (Number(snap.verdesTodos) || 0) - prev.verdes + next.verdes,
            amarillosTodos: (Number(snap.amarillosTodos) || 0) - prev.amarillos + next.amarillos,
            sinResponderTodos: (Number(snap.sinResponderTodos) || 0) - prev.sinResponder + next.sinResponder,
            ...maxHoraSinContestarDeMap(map),
          }
          return
        }

        this.conteoVendedorasSnapshot = parcial
      },

      conteoTiempoVendedora (item) {
        const id = Number(item && (item.iderp || item.id_usuario_asignado || item.idusuario)) || 0
        const base = this.conteoTiemposVendedoras.map[id] || {
          verdes: 0,
          amarillos: 0,
          sinResponder: 0,
          horaSinContestarMs: 0,
          horaSinContestar: '—',
        }
        const color = colorHoraSinContestar(base.horaSinContestarMs)
        return {
          ...base,
          horaSinContestarColor: color,
          horaSinContestarClase: claseTextoHoraSinContestar(color),
        }
      },

      ordenarVendedorasPorVerdes (lista) {
        const base = Array.isArray(lista) ? lista : []
        return base.slice().sort((a, b) => {
          const verdesA = this.conteoTiempoVendedora(a).verdes
          const verdesB = this.conteoTiempoVendedora(b).verdes
          return verdesB - verdesA
        })
      },

      examenListasChats () {
        return [this.getConversacionesFast, this.conversaciones]
      },

      /**
       * Socket twilio-unificado-bump / recibir-mensaje-twilio → fecha México y subir chat.
       */
      backgroundUpdateChat (payload) {
        // TEMP: desactivado actualización en vivo de mensajes/chats por socket
        return
        if (!payload || typeof payload !== 'object') return
        const usuario = payload.usuario || payload.from
        if (!usuario) return

        const miId = Number(
          this.getdatosUsuarioERPERP
            && (this.getdatosUsuarioERPERP.iderp || this.getdatosUsuarioERPERP.id_usuario)
        )
        const asignado = payload.usuario_asignado != null
          ? Number(payload.usuario_asignado)
          : null
        if (
          !this.accesosBoton
          && Number.isFinite(asignado)
          && asignado > 0
          && Number.isFinite(miId)
          && miId > 0
          && asignado !== miId
        ) {
          return
        }

        // Puesto 18: no meter en lista bumps sin folio ni idprospectos
        const existentePrev = Array.isArray(this.getConversacionesFast)
          ? this.getConversacionesFast.find((c) => c && c.usuario === usuario)
          : (Array.isArray(this.conversaciones)
            ? this.conversaciones.find((c) => c && c.usuario === usuario)
            : null)
        const candidatoProspecto = {
          folio: payload.folio != null ? payload.folio : (existentePrev && existentePrev.folio),
          idprospectos: payload.idprospectos != null
            ? payload.idprospectos
            : (existentePrev && existentePrev.idprospectos),
        }
        if (debeOcultarChatSinProspectoPuesto18(this.getdatosUsuarioERPERP, candidatoProspecto)) {
          return
        }

        const esMio = Number(payload.mio) === 1
        const limpiaReasignado = mensajeLimpiaReasignado(payload)
        const notifOff = localStorage.getItem('notificaciones') === 'false'
        const ahoraMs = Date.now()
        const ahora = formatFechaMexicoFront(ahoraMs)
        const messageSid = payload.messageSid || null

        let conversaciones = Array.isArray(this.getConversacionesFast) && this.getConversacionesFast.length
          ? [...this.getConversacionesFast]
          : (Array.isArray(this.conversaciones) ? [...this.conversaciones] : [])

        const idx = conversaciones.findIndex((c) => c && c.usuario === usuario)
        let item
        if (idx >= 0) {
          item = {
            ...conversaciones[idx],
            mensaje: payload.mensaje != null ? payload.mensaje : conversaciones[idx].mensaje,
            mio: esMio ? 1 : 0,
            fecha_ultimo_mensaje: ahora,
            _bumpAt: ahoraMs,
            ventanaCerrada: 0,
            tiemporestante: 24,
          }
          if (payload.folio) item.folio = payload.folio
          if (payload.idprospectos) item.idprospectos = payload.idprospectos
          if (payload.usuario_asignado != null) item.usuario_asignado = payload.usuario_asignado
          if (payload.nombre_completo) item.nombre_completo = payload.nombre_completo
          if (payload.ProfileName) item.ProfileName = payload.ProfileName
          if (payload.idetapa != null) item.idetapa = payload.idetapa
          conversaciones.splice(idx, 1)
        } else {
          item = {
            usuario,
            mensaje: payload.mensaje || '',
            mio: esMio ? 1 : 0,
            type: payload.type != null ? payload.type : 1,
            fecha_ultimo_mensaje: ahora,
            _bumpAt: ahoraMs,
            ventanaCerrada: 0,
            tiemporestante: 24,
            ProfileName: payload.ProfileName || null,
            nombre_completo: payload.nombre_completo || payload.ProfileName || null,
            folio: payload.folio || null,
            idprospectos: payload.idprospectos || null,
            usuario_asignado: payload.usuario_asignado || null,
            idetapa: payload.idetapa != null ? payload.idetapa : null,
            existe: true,
            sinleer: 0,
          }
        }

        const chatAbierto = !!(this.chat && this.chat.usuario === usuario)
        if (!chatAbierto && !esMio) {
          item.sinleer = (Number(item.sinleer) || 0) + 1
        }
        if (chatAbierto) item.sinleer = 0
        if (limpiaReasignado) {
          item.reasignado = 0
          if (esMio) item.sinleer = 0
        }

        conversaciones.unshift(item)
        conversaciones = ordenarChatsPorMasReciente(conversaciones)

        this.conversaciones = conversaciones
        if (typeof this.guardarConversacionesFast === 'function') {
          this.guardarConversacionesFast(conversaciones)
        }

        if (chatAbierto && Array.isArray(this.mensajes)) {
          const ya = messageSid && this.mensajes.some((m) => m && m.messageSid === messageSid)
          if (!ya) {
            this.mensajes.push({
              ...payload,
              fecha_creacion: ahora,
              fecha_ultimo_mensaje: ahora,
            })
            this.$nextTick(() => {
              const el = document.getElementById('scroll-target')
              if (el) el.scrollTop = el.scrollHeight
            })
          }
          if (typeof this.onMensajeTwilioEnVivo === 'function') {
            this.onMensajeTwilioEnVivo(payload)
          }
        } else if (!notifOff && !esMio && typeof this.crearTemplateSonido === 'function') {
          try { this.crearTemplateSonido() } catch (_) { /* noop */ }
        }
      },

      examenRecargarChats () {
        return this.initialize(2)
      },

      getTwilioTmp(){
        let twilioTmp = sessionStorage.getItem('twilioTmp');
        if (twilioTmp) {
          this.buscarUsuario = twilioTmp;
          sessionStorage.removeItem('twilioTmp');
        }
      },

      onCerrarAvisoCerrado () {
        this.avisoBusquedaCerrado = null
      },

      programarValidacionBusquedaCerrado (value) {
        if (this.timerBusquedaCerrado) {
          clearTimeout(this.timerBusquedaCerrado)
          this.timerBusquedaCerrado = null
        }

        const q = String(value || '').trim()
        if (!q || q.length < 4) {
          this.avisoBusquedaCerrado = null
          this.cargandoBusquedaCerrado = false
          return
        }

        this.timerBusquedaCerrado = setTimeout(() => {
          this.validarBusquedaCerradoEnBd(q)
        }, 450)
      },

      async validarBusquedaCerradoEnBd (q) {
        const query = String(q || '').trim()
        if (!query || query.length < 4) return
        if (String(this.buscarUsuario || '').trim() !== query) return

        const reqId = ++this.reqBusquedaCerrado
        this.cargandoBusquedaCerrado = true

        try {
          // 1) Si el chat ya está cargado y trae finalizo=1, avisar sin esperar API
          const avisoLocal = this.avisoCerradoDesdeChatsCargados(query)
          if (avisoLocal) {
            this.mostrarAvisoCerrado(avisoLocal)
            await this.abrirProspectoCerradoEnVista(query)
            return
          }

          // 2) Consulta dedicada
          let data = null
          try {
            const response = await this.$http.post('twilio.buscar.cerrado', {
              busqueda: query,
              escuela: 2,
              twilio: this.numeroTwilio,
            })
            data = response.data || {}
          } catch (errBuscar) {
            // 3) Fallback a endpoint ya existente
            try {
              data = await this.fallbackBuscarCerradoProspectos(query)
            } catch (errFallback) {
              data = null
              console.warn('No se pudo validar prospecto cerrado', errBuscar, errFallback)
            }
          }

          if (reqId !== this.reqBusquedaCerrado) return
          if (String(this.buscarUsuario || '').trim() !== query) return

          if (data && data.cerrado) {
            this.mostrarAvisoCerrado(data.mensaje || 'Este número y folio ya está cerrado')
            await this.abrirProspectoCerradoEnVista(query, data)
          } else {
            this.avisoBusquedaCerrado = null
          }
        } catch (error) {
          if (reqId !== this.reqBusquedaCerrado) return
          this.avisoBusquedaCerrado = null
          console.warn('Error validando número/folio cerrado', error)
        } finally {
          if (reqId === this.reqBusquedaCerrado) {
            this.cargandoBusquedaCerrado = false
          }
        }
      },

      mostrarAvisoCerrado (mensaje) {
        this.avisoBusquedaCerrado = mensaje
      },

      limpiarFiltrosParaBusquedaCerrado () {
        this.filtroMensajes = false
        this.filtroHielo = false
        this.filtroFuego = false
        this.filtroFinalizo = false
        this.filtroAgenteIA = false
        this.filtroVistos = false
        this.etiqueta = null
        this.filtroTiempo = null
        this.filtroSinProspecto = null
        this.filtroSinProspectoNoInteres = false
        this.filtroIncompletos = null
        this.etapa = 8

        const tieneEquipo =
          Array.isArray(this.vendedorasTwilio) && this.vendedorasTwilio.length > 0

        if (!this.accesosBoton && tieneEquipo) {
          this.filtroVendedora = {
            iderp: null,
            nombre: 'Todos',
            esTodos: true,
          }
        } else if (this.accesosBoton) {
          this.filtroVendedora = null
        }
      },

      encontrarChatLocalPorBusqueda (query) {
        const listas = [
          ...(Array.isArray(this.getConversacionesFast) ? this.getConversacionesFast : []),
          ...(Array.isArray(this.conversaciones) ? this.conversaciones : []),
        ]
        return listas.find((chat) => chatCoincideBusquedaTwilio(chat, query)) || null
      },

      async buscarChatCerradoEnServidor (query) {
        try {
          const response = await this.$http.post('twilio.chats.buscar', {
            busqueda: query,
            twilio: this.numeroTwilio,
            idusuario: this.getdatosUsuarioERPERP.iderp,
            escuela: 2,
            incluirCerrados: true,
          })
          const data = response.data || {}
          if (!data.encontrado || !data.chat) return null
          return { ...data.chat, sinleer: data.chat.sinleer || 0, finalizo: 1 }
        } catch (error) {
          console.warn('No se pudo buscar chat cerrado', error)
          return null
        }
      },

      chatSintenticoDesdeCerrado (query, dataCerrado = null) {
        const tel = String(
          (dataCerrado && dataCerrado.telefono)
          || String(query).replace(/\D/g, '').slice(-10)
          || ''
        ).replace(/\D/g, '').slice(-10)
        if (!tel && !(dataCerrado && dataCerrado.folio)) return null

        return {
          usuario: tel ? `whatsapp:+521${tel}` : `folio:${(dataCerrado && dataCerrado.folio) || query}`,
          folio: (dataCerrado && dataCerrado.folio) || null,
          idprospectos: (dataCerrado && dataCerrado.idprospectos) || null,
          nombre_completo: (dataCerrado && dataCerrado.nombre_completo) || null,
          nombre: (dataCerrado && dataCerrado.nombre_completo) || null,
          usuario_asignado: (dataCerrado && dataCerrado.usuario_asignado) || null,
          finalizo: 1,
          sinleer: 0,
          tiemporestante: 0,
          totalMensajes: 0,
          mensaje: '',
          sin_historial_twilio: 1,
        }
      },

      inyectarChatCerradoEnLista (chat) {
        if (!chat || !chat.usuario) return
        const arr = Array.isArray(this.conversaciones) ? [...this.conversaciones] : []
        const idx = arr.findIndex((c) => c && c.usuario === chat.usuario)
        if (idx >= 0) {
          arr[idx] = { ...arr[idx], ...chat, finalizo: 1 }
        } else {
          arr.unshift({ ...chat, finalizo: 1 })
        }
        this.conversaciones = arr
        this.guardarConversacionesFast(arr)
        if (typeof this.setVendedorAsignado === 'function') {
          this.setVendedorAsignado()
        }
      },

      async abrirProspectoCerradoEnVista (query, dataCerrado = null) {
        this.limpiarFiltrosParaBusquedaCerrado()

        let chat = this.encontrarChatLocalPorBusqueda(query)
        if (!chat) {
          chat = await this.buscarChatCerradoEnServidor(query)
        }
        if (!chat) {
          chat = this.chatSintenticoDesdeCerrado(query, dataCerrado)
        }
        if (!chat) return

        const enriquecido = {
          ...chat,
          finalizo: 1,
          folio: (dataCerrado && dataCerrado.folio) || chat.folio || null,
          idprospectos: (dataCerrado && dataCerrado.idprospectos) || chat.idprospectos || null,
          nombre_completo: (dataCerrado && dataCerrado.nombre_completo) || chat.nombre_completo || null,
        }

        this.inyectarChatCerradoEnLista(enriquecido)
        await this.$nextTick()
        this.verChat(enriquecido)
      },

      avisoCerradoDesdeChatsCargados (query) {
        const match = this.encontrarChatLocalPorBusqueda(query)
        if (!match || Number(match.finalizo) !== 1) return null
        const tel = String(match.usuario || match.telefono || '').replace(/\D/g, '').slice(-10)
        const folio = match.folio || '—'
        return `Este número ${tel || '—'} y folio ${folio} ya está cerrado`
      },

      async fallbackBuscarCerradoProspectos (query) {
        const digits = String(query).replace(/\D/g, '')
        const last10 = digits.length >= 10 ? digits.slice(-10) : ''
        const looksLikeFolio = /[A-Za-z]/.test(query)
        const payload = {
          telefono: looksLikeFolio ? '' : (last10 || query),
          folio: looksLikeFolio ? query : '',
        }
        const response = await this.$http.post('obtener.prospectos.finalizados', payload)
        const rows = Array.isArray(response.data) ? response.data : []
        const cerrado = rows.find((r) => Number(r.finalizo) === 1)
        if (!cerrado) {
          return { encontrado: rows.length > 0, cerrado: false, mensaje: null }
        }
        const tel = String(cerrado.telefono || '').replace(/\D/g, '').slice(-10)
        const folio = cerrado.folio || '—'
        return {
          encontrado: true,
          cerrado: true,
          folio,
          telefono: tel,
          idprospectos: cerrado.idprospectos,
          mensaje: `Este número ${tel || '—'} y folio ${folio} ya está cerrado`,
        }
      },

      formatearNombre(nombreCompleto) {
        if (!nombreCompleto || typeof nombreCompleto !== 'string') {
          return '';
        }

        return nombreCompleto
          .trim()                          // quita espacios sobrantes al inicio y final
          .toLowerCase()                   // todo a minúsculas primero
          .split(/\s+/)                    // divide por uno o más espacios
          .map(palabra =>
            palabra.charAt(0).toUpperCase() + palabra.slice(1)
          )
          .join(' ');
      },

      onScroll (e) {
        this.offsetTop = e.target.scrollTop
      },

      ...mapActions('twilio', ['guardarConversaciones', 'guardarConversacionesM', 'guardarConversacionesG', 'guardarConversacionesC', 'guardarConversacionesFast'] ),

      parseChatsApiResponse (data) {
        if (Array.isArray(data)) {
          return {
            chats: data,
            pagination: { hasMore: false, offset: 0, returned: data.length, limit: null },
          }
        }

        var chats = data && Array.isArray(data.chats) ? data.chats : []
        return {
          chats: chats,
          pagination: (data && data.pagination) || {
            hasMore: false,
            offset: 0,
            returned: chats.length,
            limit: null,
          },
        }
      },

      setVendedorAsignado () {
        if (!Array.isArray(this.conversaciones)) return

        const lista = this.vendedorasTwilio.length ? this.vendedorasTwilio : this.vendedoras_plantel
        if (lista && lista.length) {
          this.conversaciones.forEach(it => {
            const idUsuarioAsignado = Number(it.usuario_asignado)
            if (!idUsuarioAsignado) return
            const vendedor = lista.find(vp => Number(vp.iderp) === idUsuarioAsignado)
            if (vendedor) {
              it.vendedor = {
                ...vendedor,
                nombre: this.formatearNombre(vendedor.nombre),
              }
            }
          })
        }
      },

      async fetchChatsPage ({ offset = 0, escuela, numTwilio } = {}) {
        const numeroTwilio = this.numeroTwilio || numTwilio
        const payload = {
          twilio: numeroTwilio,
          idusuario: this.filtroVendedora ? this.filtroVendedora.iderp : this.getdatosUsuarioERPERP.iderp,
          escuela: escuela ? escuela : this.getEscuela,
          offset,
          limit: this.chatsApiPageSize,
        }

        const t0 = offset === 0 ? performance.now() : null
        const response = await this.$http.post('twilio.chats', payload)
        if (t0 != null) {
          this.tiempoCargaMs = Math.round(performance.now() - t0)
        }
        const parsed = this.parseChatsApiResponse(response.data)
        const chats = parsed.chats.map(it => ({ ...it, sinleer: it.sinleer || 0 }))
        return { chats, pagination: parsed.pagination }
      },

      // Override del initialize del mixin: asegura sincronía local + store (patrón similar a Unificado)
      initialize ( escuela, numTwilio ) {
        this.cargar = true
        this.limite = 30
        this.tiempoCargaMs = null
        // Evita flash de chats viejos del store mientras llega la API
        this.conversaciones = []
        this.guardarConversacionesFast([])

        return this.fetchChatsPage({ offset: 0, escuela, numTwilio }).then(page => {
          this.conversaciones = page.chats
          this.chatsPagination = page.pagination
          this.setVendedorAsignado()
          this.guardarConversacionesFast(this.conversaciones)
          this.actualizarConteoVendedorasSnapshot(this.chatsMenuEncargadas)
          this.$nextTick(() => this.tryAbrirChatExamenPendiente())
        }).catch(error => {
          this.tiempoCargaMs = null
          const msg =
            (error && error.response && error.response.data && error.response.data.message)
              ? error.response.data.message
              : (error && error.message)
                ? error.message
                : 'Error al obtener chats'
          this.validarError(msg)
        }).finally(() => {
          this.cargar = false
        })
      },

      seleccionaVendedora(item) {
        this.filtroVendedora = item
      },

      limpiarFiltrosLista() {
        this.filtroMensajes = false
        this.filtroHielo = false
        this.filtroRecomendados = false
        this.filtroFuego = false
        this.filtroFinalizo = false
        this.filtroAgenteIA = false
        this.filtroVistos = false
        this.etiqueta = null
        this.filtroTiempo = null
        this.filtroSinProspecto = null
        this.filtroSinProspectoNoInteres = false
        this.filtroIncompletos = null

        const tieneEquipo =
          Array.isArray(this.vendedorasTwilio) && this.vendedorasTwilio.length > 0

        if (!this.accesosBoton && tieneEquipo) {
          this.filtroVendedora = {
            iderp: null,
            nombre: 'Todos',
            esTodos: true,
          }
        } else {
          this.filtroVendedora = null
        }
      },

      activarFiltroFuego() {
        if (this.filtroFuego) {
          this.filtroFuego = false
          return
        }
        this.filtroFuego = true
        this.filtroHielo = false
        this.filtroFinalizo = false
        this.filtroAgenteIA = false
      },
      activarFiltroHielo() {
        if (this.filtroHielo) {
          this.filtroHielo = false
          return
        }
        this.filtroHielo = true
        this.filtroFuego = false
        this.filtroFinalizo = false
        this.filtroAgenteIA = false
      },
      activarFiltroRecomendados() {
        this.filtroRecomendados = !this.filtroRecomendados
      },
      activarFiltroMensajes() {
        this.filtroMensajes = !this.filtroMensajes
      },
      seleccionarEtiqueta(item) {
        if (this.etiqueta && this.etiqueta.idetiquetas == item.idetiquetas) {
          this.etiqueta = null
          return
        }
        this.etiqueta = item
      },
      onClickBotonEtiqueta() {
        if (this.etiqueta) this.etiqueta = null
      },
      onClickBotonTiempo() {
        if (this.filtroTiempo) this.filtroTiempo = null
      },
      seleccionarFiltroTiempo(item) {
        if (this.filtroTiempo && this.filtroTiempo.idtiempos == item.idtiempos) {
          this.filtroTiempo = null
          return
        }
        this.filtroTiempo = item
      },
      activarFiltroFinalizo() {
        if (!this.puedeVerFiltroFinalizo) return
        if (this.filtroFinalizo) {
          this.filtroFinalizo = false
          return
        }
        this.filtroFinalizo = true
        this.filtroFuego = false
        this.filtroHielo = false
        this.filtroAgenteIA = false
        this.filtroIncompletos = null
        this.filtroMensajes = false
        this.filtroVistos = false
        this.etiqueta = null
      },

      activarFiltroAgenteIA() {
        if (!this.puedeVerFiltroAgenteIA) return
        if (this.filtroAgenteIA) {
          this.filtroAgenteIA = false
          return
        }
        this.filtroAgenteIA = true
        this.filtroFuego = false
        this.filtroHielo = false
        this.filtroFinalizo = false
        this.filtroIncompletos = null
        this.filtroMensajes = false
        this.filtroVistos = false
        this.etiqueta = null
      },

      async getUsersChats() {
        this.cargar = true
        this.tiempoCargaMs = null
        this.conversaciones = []
        this.guardarConversacionesFast([])

        try {
          let idusuarios = []
          if (this.vendedorasTwilio && this.vendedorasTwilio.length) {
            idusuarios = this.vendedorasTwilio.map((it) => it.iderp).filter(Boolean)
          } else if (this.vendedoras_plantel && this.vendedoras_plantel.length) {
            idusuarios = this.vendedoras_plantel.map((it) => it.iderp || it.idusuario).filter(Boolean)
          }
          idusuarios.push(this.getdatosUsuarioERPERP.iderp)
          idusuarios = [...new Set(idusuarios.map((id) => Number(id)).filter(Boolean))]

          const t0 = performance.now()
          const pages = await Promise.all(
            idusuarios.map((idusuario) =>
              this.$http
                .post('twilio.chats', {
                  twilio: this.numeroTwilio,
                  idusuario,
                  escuela: 2,
                  limit: this.chatsApiPageSize,
                  offset: 0,
                })
                .then((response) => this.parseChatsApiResponse(response.data).chats || [])
                .catch(() => [])
            )
          )
          this.tiempoCargaMs = Math.round(performance.now() - t0)

          const porUsuario = new Map()
          pages.flat().forEach((chat) => {
            if (!chat || !chat.usuario) return
            const prev = porUsuario.get(chat.usuario)
            if (!prev) {
              porUsuario.set(chat.usuario, { ...chat, sinleer: chat.sinleer || 0 })
              return
            }
            const fNew = new Date(chat.fecha_ultimo_mensaje || 0).getTime()
            const fOld = new Date(prev.fecha_ultimo_mensaje || 0).getTime()
            if (fNew >= fOld) {
              porUsuario.set(chat.usuario, { ...chat, sinleer: chat.sinleer || 0 })
            }
          })

          this.conversaciones = Array.from(porUsuario.values())
          this.chatsPagination = {
            hasMore: false,
            offset: 0,
            returned: this.conversaciones.length,
            limit: this.chatsApiPageSize,
          }
          this.setVendedorAsignado()
          this.guardarConversacionesFast(this.conversaciones)
          this.actualizarConteoVendedorasSnapshot(this.chatsMenuEncargadas)
          this.$nextTick(() => this.tryAbrirChatExamenPendiente())
        } catch (error) {
          console.error(error)
          this.conversaciones = []
          this.guardarConversacionesFast([])
          this.tiempoCargaMs = null
        } finally {
          this.cargar = false
        }
      },

      async onCargarMasChats ({ limiteVisible, total } = {}) {
        if (limiteVisible != null && total != null && limiteVisible < total) {
          this.limite = limiteVisible
          return
        }

        if (this.limite < this.filterChats.length) {
          this.limite += 50
          return
        }

        const pag = this.chatsPagination
        if (!pag || !pag.hasMore || this.cargandoMasChats) return

        this.cargandoMasChats = true
        try {
          const nextOffset = (pag.offset || 0) + (pag.returned || 0)
          const page = await this.fetchChatsPage({ offset: nextOffset })
          if (!page.chats.length) return

          this.conversaciones = this.conversaciones.concat(page.chats)
          this.chatsPagination = page.pagination
          this.setVendedorAsignado()
          this.guardarConversacionesFast(this.conversaciones)
          this.actualizarConteoVendedorasSnapshot(this.chatsMenuEncargadas)
          this.limite += 50
        } catch (error) {
          console.error(error)
        } finally {
          this.cargandoMasChats = false
        }
      },

      getNombre( texto ){
        return texto.usuario
      },

      /** Tras reasignar desde el diálogo: chip azul + puntito al instante */
      onReasignacionManual (payload = {}) {
        const usuarios = Array.isArray(payload.usuarios) && payload.usuarios.length
          ? payload.usuarios
          : [(payload && payload.usuario) || (this.chat && this.chat.usuario)].filter(Boolean)

        if (!usuarios.length) return

        const prospectosPorUsuario = {}
        ;(payload.prospectos || []).forEach((p) => {
          if (p && p.usuario) prospectosPorUsuario[p.usuario] = p
        })

        const conversaciones = [...(this.getConversacionesFast || [])]
        const setUsuarios = {}
        usuarios.forEach((u) => { setUsuarios[u] = true })

        for (const i in conversaciones) {
          if (!setUsuarios[conversaciones[i].usuario]) continue
          conversaciones[i].reasignado = 1
          conversaciones[i].sinleer = 1
          conversaciones[i].mio = 0
          if (payload.usuario_asignado != null) {
            conversaciones[i].usuario_asignado = payload.usuario_asignado
          }
          if (payload.nombre_vendedora) {
            conversaciones[i].vendedor = Object.assign({}, conversaciones[i].vendedor || {}, {
              nombre: payload.nombre_vendedora,
            })
          }
          const creado = prospectosPorUsuario[conversaciones[i].usuario]
          if (creado) {
            if (creado.idprospectos) conversaciones[i].idprospectos = creado.idprospectos
            if (creado.folio) conversaciones[i].folio = creado.folio
          }
        }
        this.guardarConversacionesFast(conversaciones)

        if (this.chat && setUsuarios[this.chat.usuario]) {
          this.$set(this.chat, 'reasignado', 1)
          this.$set(this.chat, 'sinleer', 1)
          this.$set(this.chat, 'mio', 0)
          if (payload.usuario_asignado != null) {
            this.$set(this.chat, 'usuario_asignado', payload.usuario_asignado)
          }
          if (payload.nombre_vendedora) {
            this.$set(this.chat, 'vendedor', Object.assign({}, this.chat.vendedor || {}, {
              nombre: payload.nombre_vendedora,
            }))
          }
          const creadoAbierto = prospectosPorUsuario[this.chat.usuario]
          if (creadoAbierto) {
            if (creadoAbierto.idprospectos) this.$set(this.chat, 'idprospectos', creadoAbierto.idprospectos)
            if (creadoAbierto.folio) this.$set(this.chat, 'folio', creadoAbierto.folio)
          }
        }

        this.chatsSeleccionados = []
        this.reasignacionMasiva = false
      },

      abrirReasignacionIndividual () {
        this.reasignacionMasiva = false
        this.dialogReasignar.estatus = true
      },

      abrirReasignacionMasiva () {
        if (!this.chatsSeleccionados.length) {
          return this.validarError('Selecciona al menos un chat en la lista')
        }
        this.reasignacionMasiva = true
        this.dialogReasignar.estatus = true
      },

      verChat( chat ){

        // Construimos el chat
        const payload = {
          twilio      : this.numeroTwilio,
          usuario     : chat.usuario,
        }

        // Vaciamos los mensajes
        this.cargar   = true
        this.mensajes = []

        const t0Chat = this.iniciarTiempoCargaChat()
        // Hacemos la petición de los mensajes
        return this.$http.post('twilio.chats.unico', payload ).then(response=>{
          this.finalizarTiempoCargaChat(t0Chat)

          // Guardamos los mensajes
          this.mensajes   = response.data.conversacionCompleta
          let bloqueo     = response.data.bloqueo

          let conversaciones = [...this.getConversacionesFast];

          // Si existe.... hay que cambiarle el estatus
          for( const i in conversaciones ){

            const { usuario } = conversaciones[i]

            if( usuario == chat.usuario ){
              conversaciones[i].sinleer = 0
            }

          }


          if( bloqueo ){
            chat.idetiquetas = 6
          }

          this.chat = chat

          this.guardarConversacionesFast( conversaciones )

          // Lo mandamos hasta abajo el scroll
          setTimeout(function(){
            document.getElementById('scroll-target').scrollTop = document.getElementById('scroll-target').scrollHeight
          },300)

          this.cargar   = false // termina el cargar

        }).catch( error =>{
          this.limpiarTiempoCargaChat()
          const msg = (error && error.response && error.response.data && error.response.data.message)
            ? error.response.data.message
            : 'Error al abrir el chat'
          this.validarError(msg)
        }).finally( () => { this.cargar = false })
      },

      abrirPegar( event ){
        console.log( event )
      },

    },
  }
</script>

<style scoped lang="scss">
@import '@/assets/styles/twilio-whatsapp-layout.scss';

.wa-vendedoras-menu {
  min-width: 440px;
  max-width: 560px;
}
</style>
